export default "<ion-router-outlet id=\"conteudo\"></ion-router-outlet>";